import styled from 'styled-components';
import { ThemeType } from '../../types/Theme';

const PopoverInfoContainer = styled.div<{theme: ThemeType, mensagem: string, style?: React.CSSProperties, className?: string}>`
    margin-left: 1rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
    &::after {
        content: "${({mensagem}) => mensagem}";
        font-size: 12px;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        position: absolute;
        text-align: center;
        z-index: 3;
        bottom: 85%;
        left: 0;
        color: ${(props) => props.theme.colors.tertiary};
        background-color: ${(props) => props.theme.colors.elements};
        padding: 1rem;
        white-space: nowrap;
        border-radius: 5rem;
        filter: drop-shadow(0px 2px 2px #626262);
        @media (max-width: 1024px) {
            font-size: 10px;
        }
    }
    
    &::before {
        content: "";
        position: absolute;
        pointer-events: none;
        z-index: 2;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        bottom: 140%;
        left: 1rem; 
        width: 1rem;
        height: 1rem;
        transform: rotate(45deg);
    }
    
    @media (max-width: 1024px) {
        &::after {
            white-space: normal;
            width: auto;
            min-width: 40rem;
            left: 50%;
            transform: translateX(-50%);
            padding: 2rem;
        }
        &::before {
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
        }
    }
    
    &:hover {
        &::after {
            opacity: 1;
        }
        &::before {
            opacity: 1;
        }
    }
`;

export { 
    PopoverInfoContainer,
};
